module.exports = __webpack_public_path__ + "static/media/iloop.e13acad8.svg";